// @ts-check

import React from 'react';

import Button from 'infrastructure/js/components/controls/Button/button';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import WeekPickerPopover from 'infrastructure/js/components/popover/WeekPickerPopover/weekPickerPopover';

import './weekNavigation.scss';
import moment from 'moment';


export default function WeekNavigation({ weekStartDate, updateWeekStartDate, init, labels }) {


  const getWeekDatesLabel = () => {

    if (!weekStartDate) {
      return '';
    }

    const startOfWeekDate = weekStartDate.format('MMM DD').toUpperCase();
    const endOfWeekDate = weekStartDate.clone().add(6, 'd').format('MMM DD, YYYY').toUpperCase();

    let displayWeekNumber = PermissionManager.getOrgPreferences().schedulerDisplayWeekNumber || false;
    let weekLabel = labels.get('header.weekDisplay.week');
    let weekNumber = weekStartDate.week();

    if (displayWeekNumber) {
      return `${weekLabel} ${weekNumber}, ${startOfWeekDate} - ${endOfWeekDate}`;
    }

    return `${startOfWeekDate} - ${endOfWeekDate}`;

  };


  const getNextWeek = () => {
    updateWeekStartDate(weekStartDate.add(7, 'd'));
  };

  const getPreviousWeek = () => {
    // console.log('getPreviousWeek => weekStartDate ===> ', weekStartDate.toString());
    updateWeekStartDate(weekStartDate.subtract(7, 'd'));
  };

  const getToday = () => {
    init(true);
  };



  /**
   * @param {moment.Moment | null} m
   */
  let handleWeekDateSelected = (m) => {
    // console.log('handleWeekDateSelected ==> date ===> ', m && m.toString());
    if (m) {
      updateWeekStartDate(m);
    }
  }

  return (
    <div className="week-nav-container">
      <span className="week-dates">{getWeekDatesLabel()}</span>
      <div className='week-nav-buttons'>
        <Button id="today" name="today" className={'border-btn only-icon week-nav-button'} onClick={getToday}>
          {labels.get('header.dateNav.today')}
        </Button>
        <Button id="prevWeek" name="prevWeek" className={'border-btn only-icon week-nav-button'} icon={'pl pl-arrow-left'} onClick={getPreviousWeek} />

        <WeekPickerPopover
          onDateSelected={handleWeekDateSelected}
          momentDate={weekStartDate}
        />

        <Button id="nextWeek" name="nextWeek" className={'border-btn only-icon week-nav-button'} icon={'pl pl-arrow-right'} onClick={getNextWeek} />
      </div>
    </div>
  );




}


// () => {
//   const [selectedDate, setSelectedDate] = useState(new Date("2021/02/22"));
//   return (
//     <DatePicker
//       selected={selectedDate}
//       onChange={(date) => setSelectedDate(date)}
//       dateFormat="I/R"
//       locale="en-GB"
//       showWeekNumbers
//       showWeekPicker
//     />
//   );
// };



// WeekNavigation.propTypes = {
//   weekStartDate: PropTypes.object,
//   sData: PropTypes.object,
//   updateWeekStartDate: PropTypes.func,
//   init: PropTypes.func,
//   labels: PropTypes.object,
// };


